import { render, staticRenderFns } from "./ClicCollapse.vue?vue&type=template&id=e6acff5c&"
import script from "./ClicCollapse.vue?vue&type=script&lang=js&"
export * from "./ClicCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports